import { useCallback } from 'react';

export const useDownloadHandler = (element, plotLanguage, handleCapture) => {
    return useCallback(async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const loadingDiv = document.createElement('div');
        Object.assign(loadingDiv.style, {
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            padding: '20px',
            background: 'rgba(0,0,0,0.8)',
            color: 'white',
            borderRadius: '5px',
            zIndex: '9999'
        });
        loadingDiv.textContent = 'Ruošiamas atsisiuntimas...';
        document.body.appendChild(loadingDiv);

        try {
            const questionElement = event.currentTarget.closest('.question-content-wrapper');
            if (!questionElement) {
                throw new Error('Nerastas klausimo elementas');
            }

            const wrapper = document.createElement('div');
            wrapper.style.cssText = 'position:fixed;left:-9999px;top:0';
            document.body.appendChild(wrapper);

            const clone = questionElement.cloneNode(true);
            clone.classList.add('print-mode');

            // Cleanup selectors
            const selectorsToRemove = [
                '.dropdown-filter', '.filter-container', '.filter-wrapper',
                '.filter-component', '[data-html2canvas-ignore]',
                '.MuiSelect-root', '.MuiSelect-select', '.MuiFormControl-root',
                '.MuiInputBase-root', 'select', '.select-wrapper', '.select-container'
            ];
            const keywordsToRemove = ['filter', 'select', 'dropdown', 'menu'];

            // Remove elements by selectors
            clone.querySelectorAll(selectorsToRemove.join(',')).forEach(el => el.remove());

            // Remove elements by keywords
            clone.querySelectorAll('*').forEach(el => {
                const className = el.className?.toString() || '';
                const id = el.id || '';
                if (keywordsToRemove.some(keyword => 
                    className.toLowerCase().includes(keyword) || 
                    id.toLowerCase().includes(keyword)
                )) {
                    el.remove();
                }
            });

            wrapper.appendChild(clone);

            // Handle table elements
            const tableElements = clone.querySelectorAll([
                '.ReactVirtualized__Grid',
                '.ReactVirtualized__Table',
                '.ReactVirtualized__List',
                '.ReactVirtualized__Grid__innerScrollContainer',
                '.ReactVirtualized__Table__Grid',
                '.ReactVirtualized__Table__row'
            ].join(','));

            if (tableElements.length > 0) {
                tableElements.forEach(el => {
                    Object.assign(el.style, {
                        overflow: 'hidden !important',
                        overflowX: 'hidden !important',
                        overflowY: 'hidden !important',
                        position: 'static !important',
                        transform: 'none !important',
                        width: '100% !important',
                        height: 'auto !important',
                        maxHeight: 'none !important'
                    });
                });

                clone.querySelectorAll('*').forEach(el => {
                    if (window.getComputedStyle(el).overflow !== 'visible') {
                        Object.assign(el.style, {
                            overflow: 'hidden !important',
                            overflowX: 'hidden !important',
                            overflowY: 'hidden !important'
                        });
                    }
                });

                await new Promise(resolve => setTimeout(resolve, 800));
            } else {
                await new Promise(resolve => setTimeout(resolve, 300));
            }

            const languageKey = plotLanguage === 'en' ? 'default' : plotLanguage;
            await handleCapture(clone, element.title[languageKey]);
            document.body.removeChild(wrapper);
        } catch (error) {
            console.error('Download error:', error);
            alert(error.message || 'Nepavyko paruošti atsisiuntimo');
        } finally {
            document.body.removeChild(loadingDiv);
        }
    }, [element, plotLanguage, handleCapture]);
};
